import { Stack, TextField } from "@fluentui/react";
import { useEffect, useRef, useState } from "react";
import '../styles/superadmin.css';

export interface ISSHProps {
    token : string;
    username: string;
    apiUrl: string;
    site: string;
}

const SSH: React.FunctionComponent<ISSHProps> = (props: ISSHProps) => {
    const [lines, setlines] = useState<string[]>([]);
    const [input, setinput] = useState<string>();
    const [inputBuffer, setinputBuffer] = useState<string[]>(["sudo journalctl --since \"1 hour ago\"","sudo service apache2 restart","sudo service adminbackend stop"]);
    const [selectedInputBufferIndex, setselectedInputBufferIndex] = useState<number>();

    const [fr, sfr] = useState<number>();

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        
    }, []);

    function inputkeyup(e): void {
        if (e.key === 'Enter' || e.keyCode === 13) {
            let buflines = lines;
            buflines.push(input);
            setselectedInputBufferIndex(undefined);
            let binputBuffer = inputBuffer;
            binputBuffer.push(input);
            setinputBuffer(binputBuffer);

            fetch(`${props.apiUrl}/SSH`, {
                method: "Post", 
                mode: "cors", 
                headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Accept-Encoding": "gzip, deflate ,br"
                },
                referrerPolicy: "origin-when-cross-origin", 
                body: JSON.stringify({token: props.token, username: props.username, site: props.site, command: input}), 
            }).then(async (res) => {
                const reader = res.body.getReader();
                let done, value;
                while(!done) {
                    ({done, value} = await reader.read());
                    if (value) {
                        let s: string = new TextDecoder().decode(value);
                        let o = JSON.parse(s);
                        o.forEach((ou) => {
                            ou.split("\n").forEach((su) => {
                                buflines.push(su);
                            });    
                        });
                        buflines.push(" ");
                        setlines(buflines);
                        sfr(Date.now());
                    }
                }
            }).catch(err => {
                alert(err);
            });

            setinput("");
        } else if (e.key === "ArrowUp" || e.keyCode === 38) {
            if (selectedInputBufferIndex === undefined) {
                setselectedInputBufferIndex(0);
                setinput(inputBuffer[0]);
            } else if (selectedInputBufferIndex === inputBuffer.length-1) {
                setselectedInputBufferIndex(0);
                setinput(inputBuffer[0]);
            } else {
                setselectedInputBufferIndex(selectedInputBufferIndex+1);
                setinput(inputBuffer[selectedInputBufferIndex+1]);
            }
        } else if (e.key === "ArrowDown" || e.keyCode === 40) {
            if (selectedInputBufferIndex === undefined) {
                setselectedInputBufferIndex(inputBuffer.length-1);
                setinput(inputBuffer[inputBuffer.length-1]);
            } else if (selectedInputBufferIndex === 0) {
                setselectedInputBufferIndex(inputBuffer.length-1);
                setinput(inputBuffer[inputBuffer.length-1]);
            } else {
                setselectedInputBufferIndex(selectedInputBufferIndex-1);
                setinput(inputBuffer[selectedInputBufferIndex-1]);
            }
        }
    }

    return (
        <Stack horizontalAlign="start" verticalAlign="start" style={{height:"100%", width: "100%", margin: 5, padding: 10 }}>
            <Stack verticalAlign="end" className="sshcontainer" onClick={() => { inputRef.current.focus(); }}>
                {lines.map((line) => {
                    return <span>{line === " " ? <br /> : line}</span>
                })}
                <Stack horizontal>
                    <span style={{color:"green"}}>serveradmin@192.168.1.254:</span>
                    <span style={{color:"blue"}}>~</span>
                    <span style={{color:"white"}}>$ </span>
                    <input ref={inputRef} autoFocus className="sshinput" value={input} onKeyUp={inputkeyup} onChange={(e) => { setinput(e.target.value); }}></input>
                </Stack>
            </Stack>
        </Stack>
    );
}

export default SSH;